import { useState, useEffect } from "react";

export default function useWindowSize() {
  /**Инициализируйте состояние с неопределенной шириной / высотой, чтобы сервер и клиент отображали совпадение*/

  const [windowSize, setWindowSize] = useState({
    width: undefined,
    height: undefined
  });

  useEffect(() => {
    /**Обработчик для вызова изменения размера окна*/
    function handleResize() {
      /**Установите ширину/высоту окна в стейте*/
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    /**Добавлене обработчика событий на изменение размеров окна браузера*/
    window.addEventListener("resize", handleResize);

    /**Вызовите обработчик сразу, чтобы состояние обновлялось с начальным размером окна*/
    handleResize();

    /**Удалить прослушиватель событий при очистке*/
    return () => window.removeEventListener("resize", handleResize);
  }, []); /**Пустой массив гарантирует, что эффект выполняется только при монтировании*/

  return windowSize;
}
